import { render, staticRenderFns } from "./InteresShowData.vue?vue&type=template&id=8ea50dc6"
import script from "./InteresShowData.vue?vue&type=script&lang=js"
export * from "./InteresShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports